import React from 'react';
import { FaAppStoreIos } from "react-icons/fa";
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";
import { TbDeviceImacCode } from "react-icons/tb";
import { FaCode } from "react-icons/fa";

const ServiceList = [
    {
        icon: <FaCode />,
        title: 'Custom Software Development',
        description: 'ERP, CRM, billing, and business applications built around your workflow.'
    },
    {
        icon: <FaAppStoreIos />,
        title: 'Mobile App Development',
        description: 'Native and cross-platform Android & iOS apps for your business.'
    },
    {
        icon: <TbDeviceImacCode />,
        title: 'Web Applications',
        description: 'Fast, secure web apps, portals, and APIs that scale with your growth.'
    }
]

const ServiceOne = ({textAlign, serviceStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`service ${serviceStyle} ${textAlign}`}>
                            <div className="icon">
                                {val.icon}
                            </div>
                            <div className="content">
                                <h4 className="title w-600"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
            <div className="services-btn mt--30" style={{ display: "flex", justifyContent: "center" }}>
                        <a className="btn-default " href="our-services">Our Services</a>
             </div>
        </div>
    )
}
export default ServiceOne;
